import { useEffect, useState } from "react";
import { Play, Maximize2, Phone } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function FloatingActions() {
  const [visible, setVisible] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => {
      setVisible(window.scrollY > 120);
    };

    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!visible) return null;

  return (
    <div className="fixed right-6 top-1/2 -translate-y-1/2 z-40">
      <div className="flex flex-col gap-2.5 bg-gradient-to-b from-[#1f1a16]/95 to-[#2a2420]/95 backdrop-blur-xl border border-[#caa85a]/30 rounded-2xl p-2.5 shadow-[0_8px_32px_rgba(202,168,90,0.15)]">

        {/* 🎬 REELS BUTTON */}
        <button
          onClick={() => navigate("/reels")}
          title="Watch Reels"
          className="group relative w-11 h-11 rounded-xl bg-gradient-to-br from-[#1f1a16] to-[#2a2420] border border-[#caa85a]/30 flex items-center justify-center hover:border-[#caa85a] hover:shadow-[0_0_20px_rgba(202,168,90,0.4)] transition-all duration-300 overflow-hidden"
        >
          <div className="absolute inset-0 bg-gradient-to-br from-[#caa85a]/0 to-[#caa85a]/0 group-hover:from-[#caa85a]/10 group-hover:to-[#caa85a]/5 transition-all duration-300" />
          <Play className="w-4 h-4 text-[#caa85a] group-hover:text-[#d4b76a] group-hover:scale-110 transition-all duration-300 relative z-10" />
        </button>

        {/* 360 VIEW */}
        <button className="group relative w-11 h-11 rounded-xl bg-gradient-to-br from-[#1f1a16] to-[#2a2420] border border-[#caa85a]/30 flex items-center justify-center">
          <Maximize2 className="w-4 h-4 text-[#caa85a]" />
        </button>

        {/* CALL */}
        <a href="tel:+917001307267" className="group relative w-11 h-11 rounded-xl bg-gradient-to-br from-[#1f1a16] to-[#2a2420] border border-[#caa85a]/30 flex items-center justify-center">
          <Phone className="w-4 h-4 text-[#caa85a]" />
        </a>

      </div>
    </div>
  );
}
